import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Projectgoal() {
  return (
    <section className="p-100 bg_textcolor" style={{ background: "#DE1A36" }}>
      <Container>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
            <h2 >Project Goal</h2>
            <p>More and more businesses have started advocating the employee wellbeing and fitness. Our client, as a modern leader understands that employee wellness is a primary factor in any organization’s success. Workers’ physical, mental and emotional health impact the overall efficiency and effectiveness of business operations, regardless of the sector or market a business operates in.</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectgoal;
